import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';


// Redux slices
import { updateObjectData } from './objectSlice';

// SemanticUI components
import { Form, FormField, Flag, Container, Header, Label, TextArea, FormInput, Icon, HeaderContent } from 'semantic-ui-react';

// Style
import './object.css';


/**
 * 
 * @returns 
 */
const Max2Texts = () => {
  // local State
  const [language, setLanguage] = useState('deu');
  const textareasRef = useRef([]);

  // global State
  const dispatch  = useDispatch();
  const editMode    = useSelector((state) => state.object.sections.Texts.edit)
  const object      = useSelector((state) => state.object.data);

  // Translations
  const { t } = useTranslation();

  

  //
  const textLabels = {
    ABHInfo:                { format: 'TEXTAREA', label: t('object.texts.ABHInfo.label'), placeholder: t('object.texts.ABHInfo.placeholder'), value: '' },
    HLXInfo:                { format: 'TEXTAREA', label: t('object.texts.HLXInfo.label'), placeholder: t('object.texts.HLXInfo.placeholder'), value: '' },
    LHHInfo:                { format: 'TEXTAREA', label: t('object.texts.LHHInfo.label'), placeholder: t('object.texts.LHHInfo.placeholder'), value: '' },
    Intro:                  { format: 'TEXTAREA', label: t('object.texts.Intro.label'), placeholder: t('object.texts.Intro.placeholder'), value: '' },
    Location:               { format: 'TEXTAREA', label: t('object.texts.Location.label'), placeholder: t('object.texts.Location.placeholder'), value: '' },
    Arrival:                { format: 'TEXTAREA', label: t('object.texts.Arrival.label'), placeholder: t('object.texts.Arrival.placeholder'), value: '' },
    NumberOfRooms:          { format: 'INPUT',    label: t('object.texts.NumberOfRooms.label'), placeholder: t('object.texts.NumberOfRooms.placeholder'), value: '' },
    FacilityEquipment:      { format: 'TEXTAREA', label: t('object.texts.FacilityEquipment.label'), placeholder: t('object.texts.FacilityEquipment.placeholder'), value: '' },
    AccommodationEquipment: { format: 'TEXTAREA', label: t('object.texts.AccommodationEquipment.label'), placeholder: t('object.texts.AccommodationEquipment.placeholder'), value: '' },
    Board:                  { format: 'TEXTAREA', label: t('object.texts.Board.label'), placeholder: t('object.texts.Board.placeholder'), value: '' },
    Beach:                  { format: 'TEXTAREA', label: t('object.texts.Beach.label'), placeholder: t('object.texts.Beach.placeholder'), value: '' },
    BeachDistance:          { format: 'INPUT',    label: t('object.texts.BeachDistance.label'), placeholder: t('object.texts.BeachDistance.placeholder'), value: '' },
    Children:               { format: 'TEXTAREA', label: t('object.texts.Children.label'), placeholder: t('object.texts.Children.placeholder'), value: '' },
    Sports:                 { format: 'TEXTAREA', label: t('object.texts.Sports.label'), placeholder: t('object.texts.Sports.placeholder'), value: '' },
    SportsWithoutFee:       { format: 'TEXTAREA', label: t('object.texts.SportsWithoutFee.label'), placeholder: t('object.texts.SportsWithoutFee.placeholder'), value: '' },
    SportsWithFee:          { format: 'TEXTAREA', label: t('object.texts.SportsWithFee.label'), placeholder: t('object.texts.SportsWithFee.placeholder'), value: '' },
    Wellness:               { format: 'TEXTAREA', label: t('object.texts.Wellness.label'), placeholder: t('object.texts.Wellness.placeholder'), value: '' },
    Entertainment:          { format: 'TEXTAREA', label: t('object.texts.Entertainment.label'), placeholder: t('object.texts.Entertainment.placeholder'), value: '' },
    AdditionalInformations: { format: 'TEXTAREA', label: t('object.texts.AdditionalInformations.label'), placeholder: t('object.texts.AdditionalInformations.placeholder'), value: '' },
    RenovationInformations: { format: 'TEXTAREA', label: t('object.texts.RenovationInformations.label'), placeholder: t('object.texts.RenovationInformations.placeholder'), value: '' },
    BinoliInformations:     { format: 'TEXTAREA', label: t('object.texts.BinoliInformations.label'), placeholder: t('object.texts.BinoliInformations.placeholder'), value: '' },
    ImportantNote:          { format: 'TEXTAREA', label: t('object.texts.ImportantNote.label'), placeholder: t('object.texts.ImportantNote.placeholder'), info: t('object.texts.ImportantNote.info'), value: '' },
  }

  //
  const languages = [
    { key: 'deu', flag: 'de' },
    { key: 'eng', flag: 'uk' }, 
    { key: 'fra', flag: 'fr' },
    { key: 'spa', flag: 'es' }, 
    { key: 'ita', flag: 'it'}
  ];
  
  const adjustTextareaHeight = useCallback(() => {
    for (const index in textareasRef.current) {
      if (Object.prototype.hasOwnProperty.call(textareasRef.current, index)) {
        const textarea = textareasRef.current[index].ref.current;
        if (textarea) {
          textarea.style.height = "auto";
          textarea.style.height = `${textarea.scrollHeight}px`;
        }
      }
    }
  }, [textareasRef]);

  const descriptionTexts = object?.DescriptionsTexts[language]?.Texts;

  useEffect(() => {
    adjustTextareaHeight();
  }, [adjustTextareaHeight, descriptionTexts]);
  

  
  /**
   * 
   * @param {integer} index 
   * @param {string} value 
   */
  const handleInputChange = (index, value) => {
    dispatch(updateObjectData({section: 'Texts', language: language, key: index, value: value}))
  };
  
  
  let foundTexts = false;
  let texts = [];
  if (editMode) {
    for (const textKey in textLabels) {
      if (Object.prototype.hasOwnProperty.call(textLabels, textKey)) {
        const labelValue = textLabels[textKey];
        const textValue = object?.DescriptionsTexts[language]?.Texts[textKey];

        const countChars = typeof textValue !== 'undefined' ? textValue.length : 0;
        const countWords = typeof textValue === 'undefined' || textValue.trim() === "" ? 0 : textValue.trim().split(/\s+/).length; 
        const countCharsLabel = countChars ? <Label basic pointing size='mini' style={{float:'right'}}>{t('object.texts.charCount', { count: countChars })}</Label> : <></>;
        const countWordsLabel = countWords ? <Label basic pointing size='mini' style={{float:'right'}}>{t('object.texts.wordCount', { count: countWords })}</Label> : <></>;

        texts.push(
          <FormField key={textKey} style={{marginBottom: '35px'}}>
            <label>{labelValue.label}</label>
            {labelValue.format === 'TEXTAREA' && (
              <TextArea 
                placeholder = {labelValue.placeholder} 
                value       = {textValue} 
                label       = {{ as: 'a', color: 'red', corner: 'right', icon: 'save' }} 
                ref         = {(el) => { if (el) textareasRef.current[textKey] = el}} // Speichere die Referenz
                style       = {{ overflow: "hidden", resize: "none" }}
                onChange    = {(e) => handleInputChange(textKey, e.target.value)}
              />
            )}
            {labelValue.format === 'INPUT' && (
              <FormInput placeholder={labelValue.placeholder} value={textValue} label={{ as: 'a', color: 'red', corner: 'right', icon: 'save' }} onChange={(e) => handleInputChange(textKey, e.target.value)} />
            )}
            {countCharsLabel}
            {countWordsLabel}
          </FormField>
        );
      }
    }
  } else {
    for (const textKey in descriptionTexts) {
      if (Object.prototype.hasOwnProperty.call(descriptionTexts, textKey)) {
        const textValue = object?.DescriptionsTexts[language]?.Texts[textKey];
        if (textValue) {
          texts.push(
            <Container fluid key={textKey} style={{marginBottom: '25px'}}>
              <Header as='h4'>{textLabels[textKey].label}</Header>
              <p>{textValue}</p>
            </Container>
          );
          foundTexts = true;
        }
      }
    }
  }

  const langIcons = languages.map((lang) => {
    const style = language === lang.key ? {border: '1px solid silver'} : {opacity: '0.4', cursor: 'pointer'};
    return (<Flag key={lang.flag} name={lang.flag} onClick={()=>setLanguage(lang.key)} style={style} />);
  });

  return (
      <Form >
        <div style={{position: 'absolute', top: '-20px', right: '0px'}}>
          {langIcons}
        </div>
        <>
        {(editMode === true || foundTexts) 
          ? <>{texts}</>
          : <><Header as='h4' textAlign='center'><Icon name='times circle outline' /><HeaderContent>{t('object.texts.noEntries')}</HeaderContent></Header></>
        }
        </>
      </Form>
  )
}

export default Max2Texts;
